import { Component, ViewEncapsulation } from '@angular/core';
import { DesktopAppService } from '@intranet/core/services/desktop-app.service';

/** Default Intranet layout (sidebar + timer-header + per-page header).
 *  When the Angular app runs inside the Visarc Timer Electron shell, those
 *  chrome elements are hidden via `*ngIf="!desktopApp.isTimerApp"` in the
 *  template — see default.component.html. */
@Component({
    selector: 'layout-default',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LayoutDefaultComponent {
    /** Public so the template can read `desktopApp.isTimerApp`. */
    constructor(public desktopApp: DesktopAppService) {}
}
